import { type IntegrationServiceId } from '../../../../../../common/integrations'
import { ObjectAndFieldSelectDropdown, type ObjectAndFieldSelectDropdownProps } from './ObjectAndFieldSelectDropdown'
import './ContactLinking.scss'

type ContactLinkNodeProps = Omit<ObjectAndFieldSelectDropdownProps, 'serviceId'>

export interface ContactLinkRowProps {
  serviceId: IntegrationServiceId
  source: ContactLinkNodeProps
  target: ContactLinkNodeProps
}

export const ContactLinkRow: React.FC<ContactLinkRowProps> = ({ serviceId, source, target }) => (
  <div className='contact-link-grid__row mb-3'>
    <div className='d-flex align-items-center'>
      <ObjectAndFieldSelectDropdown serviceId={serviceId} {...source} />
    </div>
    <div className='contact-link-grid__arrow'>
      <i className='bi bi-arrow-right zocks-text-gray-500 fs-5'></i>
    </div>
    <div className='contact-link-grid__target d-flex align-items-center'>
      <ObjectAndFieldSelectDropdown serviceId={serviceId} {...target} />
    </div>
  </div>
)
